import { useEffect, useState } from "react"
import { CustomRadio } from "../../../../ui/molecules/radioButton"
import CheckboxGroup from "../../../../ui/molecules/CheckBoxGroup"
import Button from "../../../../ui/molecules/button"
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { ManipulationPopup } from "./popup"
import { TrashIcon } from "../../../../ui/icons/trash"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { GGNotificationUpdate, resetGGNotificationUpdateStatus, setGGNotUpdateManipulationExtraFarmProducts, setGGNotUpdateManipulationInnerStructures, setGGNotUpdateManipulationOtherStructuresGGWithGGN, setGGNotUpdateManipulationOtherStructuresNoGG, setGGNotUpdateManipulationPostHarvesting, setGGNotUpdateManipulationSoldProducts } from "../dataservice/slice"
import { SingleCheckbox } from "../../../../ui/molecules/SingleCheckbox"
import { GetAllManipulationDetail, ManipulationDetailDelete, resetManipulationDetailCreationStatus, resetManipulationDetailDeleteStatus, resetManipulationDetailRequest } from "./slice"
import { ManipulationDetailDTO } from "./dataservice/dto"
import { Alert } from "../../../../ui/organisms/alert"

export function GlobalGapManipolazione() {
    const dispatch = useAppDispatch()
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const manipulationDetailState = useAppSelector(state => state.ggManipulationDetail)
    const [certificationProducts, setCertificationProducts] = useState<string | null>(null)
    const [manipulation, setManipulation] = useState<string | null>(null)
    const [innerStructures, setInnerStructures] = useState<boolean>(false)
    const [otherStructuresNoGG, setOtherStructuresNoGG] = useState<boolean>(false)
    const [otherStructuresGGWithGGN, setOtherStructuresGGWithGGN] = useState<boolean>(false)
    const [extraFarmProducts, setExtraFarmProducts] = useState<boolean>(false)
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [mdToDelete, setMDTodelete] = useState<ManipulationDetailDTO | null>(null)

    useEffect(() => {
        dispatch(GetAllManipulationDetail({
            itemsPerPage: 0,
            page: 0,
            ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
        }))
    }, [])

    useEffect(() => {
        const req = ggNotificationState.ggNotificationUpdateRequest
        setCertificationProducts(req.manipulationSoldProducts ? 'SI' : 'NO')
        setManipulation(req.manipulationPostHarvesting ? 'SI' : 'NO')
        setInnerStructures(req.manipualtionInnerStructures!)
        setOtherStructuresNoGG(req.manipulationOtherStructuresNoGG!)
        setOtherStructuresGGWithGGN(req.manipulationOtherStructuresGGWithGGN!)
        setExtraFarmProducts(req.manipulationExtraFarmProducts!)
    }, [ggNotificationState.ggNotificationUpdateRequest])

    useEffect(() => {
        if (ggNotificationState.ggNotificationUpdateStatus === 'successfully') {
            dispatch(resetGGNotificationUpdateStatus())
            setShowSuccess(true)
        }
    }, [ggNotificationState.ggNotificationUpdateStatus])

    useEffect(() => {
        if(manipulationDetailState.manipulationDetailCreationStatus === 'successfully') {
            dispatch(resetManipulationDetailCreationStatus())
            dispatch(GetAllManipulationDetail({
                itemsPerPage: 0,
                page: 0,
                ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
            }))
        }
    }, [manipulationDetailState.manipulationDetailCreationStatus])

    useEffect(() => {
        if(manipulationDetailState.manipulationDetailDeleteStatus === 'successfully') {
            dispatch(resetManipulationDetailDeleteStatus())
            dispatch(GetAllManipulationDetail({
                itemsPerPage: 0,
                page: 0,
                ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
            }))
        }
    }, [manipulationDetailState.manipulationDetailDeleteStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div>
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div className="notify-container">
                <div className='notify-header'>
                    <div className='text-left'>
                        <span className='notify-title-bold' style={{ color: '#fff' }}>Domanda </span>
                        <span className='notify-title-bold' style={{ color: '#74A4A9' }}>/</span>
                        <span className='notify-title-bold' style={{ color: '#d9e6e8' }}> Manipolazione</span>
                    </div>
                </div>

                <div style={{ padding: '24px' }}>

                    <div className="mb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <span className='notify-text-content'>
                            I prodotti oggetto di certificazione sono venduti in campo prima della raccolta e che la stessa non è oggetto della presente richiesta (esclusione della fase di raccolta)
                        </span>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: 'SI' }]}
                                selectedValue={certificationProducts}
                                onChange={(value) => {
                                    setCertificationProducts(value)
                                    dispatch(setGGNotUpdateManipulationSoldProducts(true))
                                }}
                                id={'notify_certification_1'}
                                name={'notify_certification_1'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>Sì</span>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: 'NO' }]}
                                selectedValue={certificationProducts}
                                onChange={(value) => {
                                    setCertificationProducts(value)
                                    dispatch(setGGNotUpdateManipulationSoldProducts(false))
                                }}
                                id={'notify_certification_2'}
                                name={'notify_certification_2'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>No</span>
                            </div>
                        </div>
                    </div>

                    <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                        <span className='notify-text-content'>
                            Per i prodotti oggetto di certificazione viene effettuata una successiva attività di manipolazione/post-raccolta
                        </span>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: 'SI' }]}
                                selectedValue={manipulation}
                                onChange={(value) => {
                                    setManipulation(value)
                                    dispatch(setGGNotUpdateManipulationPostHarvesting(true))
                                }}
                                id={'notify_manipulation_1'}
                                name={'notify_manipulation_1'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>Sì</span>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: 'NO' }]}
                                selectedValue={manipulation}
                                onChange={(value) => {
                                    setManipulation(value)
                                    dispatch(setGGNotUpdateManipulationPostHarvesting(false))
                                }}
                                id={'notify_manipulation_2'}
                                name={'notify_manipulation_2'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>No</span>
                            </div>
                        </div>
                    </div>

                    <div className="pt-5">
                        <div className="pb-3">
                            <SingleCheckbox
                                label='La manipolazione è effettuata nelle proprie strutture'
                                checked={innerStructures}
                                setChecked={(value) => {
                                    dispatch(setGGNotUpdateManipulationInnerStructures(value))
                                    setInnerStructures(value)
                                }}
                            />
                        </div>
                        <div className="pb-3">
                            <SingleCheckbox
                                label='La manipolazione è effettuata presso altre strutture di ditte non certificate GlobalGap'
                                checked={otherStructuresNoGG}
                                setChecked={(value) => {
                                    dispatch(setGGNotUpdateManipulationOtherStructuresNoGG(value))
                                    setOtherStructuresNoGG(value)
                                }}
                            />
                        </div>
                        <div className="pb-3">
                            <SingleCheckbox
                                label='La manipolazione è effettuata presso altre strutture di ditte certificate GlobalGap con GGN'
                                checked={otherStructuresGGWithGGN}
                                setChecked={(value) => {
                                    dispatch(setGGNotUpdateManipulationOtherStructuresGGWithGGN(value))
                                    setOtherStructuresGGWithGGN(value)
                                }}
                            />
                        </div>
                        <div className="pb-3">
                            <SingleCheckbox
                                label="Manipolazione di prodotti extra-aziendali effettuata all'interno delle proprie strutture di lavorazione post-raccolta"
                                checked={extraFarmProducts}
                                setChecked={(value) => {
                                    dispatch(setGGNotUpdateManipulationExtraFarmProducts(value))
                                    setExtraFarmProducts(value)
                                }}
                            />
                        </div>
                    </div>

                    <div className="pb-5" style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                        <Button
                            variant="solid"
                            color="orange"
                            size="md"
                            iconPosition="off"
                            label="Salva"
                            onClick={() => dispatch(GGNotificationUpdate({ body: ggNotificationState.ggNotificationUpdateRequest, id: ggNotificationState.ggNotificationIdToUpdate }))}
                        />
                    </div>

                    <div className="pb-5">
                        <table id="users-table" className="w-[100%]">
                            <thead className="h-[52px] uppercase">
                                <tr>
                                    <th style={{ borderTopLeftRadius: '8px' }}></th>
                                    <th className="width-[130px]">N.</th>
                                    <th className="width-[130px]">Rag. Sociale</th>
                                    <th className="width-[100px]">Sede</th>
                                    <th className="width-[130px]">Contatti</th>
                                    <th className="width-[20%]">GGN/GLN</th>
                                    <th className="width-[130px]">P.IVA/C.F.</th>
                                    <th className="width-[130px]">Coordinate Geografiche</th>
                                    <th className="width-[130px]">Confeziona gli stessi prodotti ad altri produttori/organizzazioni?</th>
                                    <th className="width-[130px]">Certificato</th>
                                    <th className="width-[130px]">Propretà Parallela</th>
                                    <th className="width-[130px]">Prodotto/i</th>
                                    <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    manipulationDetailState.getAllManipulationDetailResponse?.data.map((m, index) =>
                                        <tr
                                            key={index}
                                            style={{
                                                color: '#4D797F',
                                                background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                            }}
                                        >
                                            <td></td>
                                            <td>{m.id}</td>
                                            <td>{m.companyName}</td>
                                            <td>{m.headQuarter}</td>
                                            <td>{m.contact}</td>
                                            <td>{m.ggnGln}</td>
                                            <td>{m.vatOrFiscalCode}</td>
                                            <td>{m.coordinates}</td>
                                            <td>{m.thirdPartyPackaging ? 'Sì' : 'No'}</td>
                                            <td>{m.isCertified ? 'Sì' : 'No'}</td>
                                            <td>{m.parallelProperty ? 'Sì' : 'No'}</td>
                                            <td>{m.products}</td>
                                            <td>
                                                <button onClick={() => {
                                                    setMDTodelete(m)
                                                    setShowAlert(true)
                                                }}>
                                                    <TrashIcon color="red" size={20} />
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>

                    <div className="pb-5" style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                        <Button
                            variant="outline"
                            color="dimgrey"
                            size="md"
                            iconPosition="off"
                            label="Aggiungi"
                            onClick={() => setShowAddPopup(true)}
                        />
                    </div>
                </div>
                {
                    showAddPopup &&
                    <PopupForm title={`Aggiungi manipolazione`} headerGreen close={() => {
                        dispatch(resetManipulationDetailRequest())
                        setShowAddPopup(false)
                        }}>
                        <ManipulationPopup close={() => setShowAddPopup(false)}></ManipulationPopup>
                    </PopupForm>
                }
                {
                    (showAlert && mdToDelete) && (
                        <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                            <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="pb-3">
                                    <div>
                                        Sei sicuro di voler eliminare il seguente dettaglio?
                                    </div>
                                    <div className="mt-3 font-bold">
                                        {`${mdToDelete.companyName}`}
                                    </div>
                                </div>
                                <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Button
                                        variant="outline"
                                        color="dimgrey"
                                        iconPosition="off"
                                        label="Annulla"
                                        size="md"
                                        onClick={() => setShowAlert(false)}
                                    />
                                    <div className="pl-8">
                                        <Button
                                            variant="solid"
                                            color="orange"
                                            iconPosition="off"
                                            label="Elimina"
                                            size="md"
                                            onClick={() => {
                                                dispatch(ManipulationDetailDelete(mdToDelete.id!))
                                                setShowAlert(false)
                                            }}
                                        />
                                    </div>
                                </div>

                            </div>
                        </Alert>
                    )
                }
            </div>
        </div>
    )
}